const dateFormatQueryString = "yyyy-MM-dd'T'HH:mm:ss";
export default dateFormatQueryString;
